import { REQUEST_STATUSES } from "@/constants/index.js";

import { currentElementSelector } from "./selectors.js";
import * as types from "./types.js";
import { ContentElementService, ElementService } from "../../../services";

export const getCurrentElement = (params) => {
  return async (dispatch) => {
    const payload = {};

    if (params.experienceId) {
      const { resp, err, status } = await ElementService.getElement(
        params.propertyId,
        params.experienceId,
        params.elementId,
      );
      payload.element = resp || {};
      payload.err = err;
      payload.status = status;
    }

    if (params.mediaItemId) {
      const { resp, err, status } = await ContentElementService.getContentElement(
        params.propertyId,
        params.mediaItemId,
        params.elementId,
      );
      payload.element = resp || {};
      payload.err = err;
      payload.status = status;
    }

    dispatch({
      type: types.GET_CURRENT_ELEMENT,
      payload,
    });
  };
};

export const setCurrentElement = (element) => {
  return async (dispatch) => {
    const payload = {
      element,
      status: REQUEST_STATUSES.SUCCEEDED,
      err: null,
    };

    dispatch({
      type: types.GET_CURRENT_ELEMENT,
      payload,
    });
  };
};

export const refreshCurrentElement = (values) => {
  return async (dispatch, getState) => {
    const { element } = currentElementSelector(getState());

    dispatch({
      type: types.REFRESH_CURRENT_ELEMENT,
      payload: { ...element, ...values },
    });
  };
};

export const resetCurrentElement = () => {
  return (dispatch) => {
    dispatch({
      type: types.RESET_CURRENT_ELEMENT,
      payload: {},
    });
  };
};
